import { createContext, useContext, useState } from "react";
import translations from "./translations";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(
    () => sessionStorage.getItem("wedding-lang") || null
  );

  const changeLang = (newLang) => {
    setLang(newLang);
    sessionStorage.setItem("wedding-lang", newLang);
  };

  const t = lang ? translations[lang] : translations.en;

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
